import {
  formatUnixTime,
  formatUTCTime,
} from "../../../global/utils/unixToLocalTime";
import {
  getOptionLabel,
  renderPrice,
  termOptions,
} from "../../../utils/Common";
export const PurchaseLicenseItemsColumns = ({ showRenewal = false } = {}) => {
  const columns = [
    {
      title: "Item",
      dataIndex: "ItemName",
      key: "ItemName",
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "Code",
      dataIndex: "CodeName",
      key: "CodeName",
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "Term",
      dataIndex: "Term",
      key: "Term",
      render: (value) => getOptionLabel(termOptions, value) || value || "",
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "Price",
      dataIndex: "Price",
      key: "Price",
      render: renderPrice,
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "Start Time",
      dataIndex: "StartTime",
      key: "StartTime",
      onHeaderCell: () => ({ onClick: () => {} }),
      render: (text) => <div>{text ? formatUTCTime(text) : ""}</div>,
    },
    {
      title: "End Time",
      dataIndex: "EndTime",
      key: "EndTime",
      onHeaderCell: () => ({ onClick: () => {} }),
      render: (text) => <div>{text ? formatUTCTime(text) : ""}</div>,
    },
  ];
  if (showRenewal) {
    columns.push({
      title: "Renewal",
      dataIndex: "Renewal",
      key: "Renewal",
      render: (value) => (Number(value) === 1 ? "Yes" : "No"),
      onHeaderCell: () => ({ onClick: () => {} }),
    });
  }
  return columns;
};
